// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__PFnr7","rootSmall":"AddTileButton_rootSmall__dxcAW"};